import React, { useContext } from 'react'

import { Tooltip } from 'antd'
import { DAY_AND_MONTH_FORMAT } from '../utils/constants'
import { GlobalContext } from '../../../../Providers/GlobalProvider'

const CONTENT_STYLE = { paddingTop: '7px' }

const NO_SCHOOL_TEXT = 'NO_SCHOOL'
const NO_SECTOR_TEXT = 'NO_SECTOR'
const DURATION_TEXT = 'Internship duration'
const QUOTAS_INFORMATION_TEXT = 'Only accepted internships are counted in the quotas.'
const INTERNSHIP_REMAINING_PLACES_TEXT = 'internship place(s) remaining for'
const INTERNSHIP_EXCESS_PLACES_TEXT = 'internship place(s) in excess for'

const QuotaDateCell = ({ context, placement, value, startDate, endDate, school, sector, t }) => {
  const { nursesMode } = useContext(GlobalContext)

  const getClassName = () => {
    if (value > 0) {
      return 'underloaded'
    }

    if (value === 0) {
      return 'balanced'
    }

    if (value < 0) {
      return 'overloaded'
    }

    return ''
  }

  const renderTitle = () => {
    const quotasInformationMessage = t(QUOTAS_INFORMATION_TEXT)
    const endOfText = `${!school ? NO_SCHOOL_TEXT : school.name}${getSectorText()}.`
    const placesText = value < 0
      ? INTERNSHIP_EXCESS_PLACES_TEXT
      : INTERNSHIP_REMAINING_PLACES_TEXT

    return (
      <div>
        <span>
          {`${Math.abs(value)} ${t(placesText)} ${endOfText}`}
          <br />
          <br />
          {quotasInformationMessage}
        </span>
        <br />
        <br />
        <div>{t(DURATION_TEXT)} </div>
        <div>{startDate.format(DAY_AND_MONTH_FORMAT)} - {endDate.format(DAY_AND_MONTH_FORMAT)}</div>
      </div>
    )
  }

  const getSectorText = () => {
    if (nursesMode) {
      return ` ${t('in')} ${!sector ? NO_SECTOR_TEXT : sector.name}`
    }

    return ''
  }

  return (
    <Tooltip placement={placement} title={renderTitle()}>
      <div className={getClassName()} style={CONTENT_STYLE}>
        {value}
      </div>
    </Tooltip>
  )
}

export default QuotaDateCell
